import React, { useEffect, useState } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import  PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import { useAuth } from '../../../../hooks/useAuth';


const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        },
    },
}

export default function ProgramLangSelect({title, dataAll, selectValue, onClose}) {
    const {authDataLang} = useAuth()
    const [personName, setPersonName] = useState([])

    useEffect(() =>{
        if(selectValue && dataAll){
            const nameList = selectValue.map((ee) => dataAll.filter(v => v.id === ee)[0]['name'])
            setPersonName(
                // On autofill we get a stringified value.
                typeof nameList === 'string' ? nameList.split(',') : nameList,
            )
        }

    }, [selectValue])

    const handleChange = (event: SelectChangeEvent<typeof personName>) => {
        const {target: { value },} = event
        // console.log(value)
        setPersonName(
            typeof value === 'string' ? value.split(',') : value,
        )
        const idList = value.map((ee) => dataAll.filter(v => v.name.includes(ee))[0]['id'])
        
        onClose(idList)
        // sameGroup()
    }

    return (
        <div >
            <FormControl sx={{ m: 1, width: 300 }}>
                <InputLabel id="demo-multiple-checkbox-label" sx={{width:300}}>
                    <Typography 
                        fontFamily='b_mitra' 
                        component="div"
                        variant="h6"
                        color={blue[900]}
                        >
                        {title}
                    </Typography>
                </InputLabel>
                <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput label={title} />}
                    renderValue={(selected) => 
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="div"
                            color={blue[900]}
                            >
                            {selected.join(', ')}
                        </Typography>
                        }
                    MenuProps={MenuProps}
                    >
                    {dataAll && dataAll?.map((langP, index) => (
                        <MenuItem key={langP.id} value={langP.name} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
                            <Checkbox checked={personName.indexOf(langP.name) > -1} />
                            <ListItemText color='blue' primary={langP.name} sx={{textAlign: (authDataLang?.view_sts ? "left" : "right")}} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    )
}


ProgramLangSelect.propTypes = {
    onClose: PropTypes.func.isRequired,
    // open: PropTypes.bool.isRequired,
    // selectedValue: PropTypes.string.isRequired,
}